<!--
 * @Author:
 * @LastEditTime: 2023-07-28
 * @Description: 风险分级管控
-->
<template>
  <el-card class="h-full relative" id="risk-identify-list">
    <el-tabs v-model="activeName">
      <el-tab-pane label="设备设施清单" name="equipmentList">
        <control-equip-table v-if="activeName === 'equipmentList'"></control-equip-table>
      </el-tab-pane>
      <el-tab-pane label="作业活动清单" name="jobList">
        <control-job-table v-if="activeName === 'jobList'"></control-job-table>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import ControlEquipTable from '../components/RiskGradingControlTable/ControlEquipTable'
import ControlJobTable from '../components/RiskGradingControlTable/ControlJobTable'

export default {
  name: 'risk-grading-control',
  components: {
    ControlEquipTable,
    ControlJobTable,
  },
  data() {
    return {
      activeName: 'equipmentList',
    }
  },
  created() {
    // tagType 1为设备设施 2为作业活动 3为基础管理
    this.activeName =
      this.$route.query.tagType && this.$route.query.tagType == 2 ? 'jobList' : 'equipmentList'
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-tabs {
  height: 100%;
}
::v-deep .el-tabs__content {
  height: calc(100% - 54px) !important;
  position: inherit;
  .el-tab-pane {
    height: 100%;
  }
}
</style>
